import { keysToSnakeCase } from 'helpers/utils';

import { IFilterParams } from 'interfaces/IFilterParams';
import { ITestObjectiveForm, ITestObjectiveEditForm } from 'interfaces/TestObjective/ITestObjective';

import { request } from './instance';

export const TestObjectiveAPI = {
  getAll: async (params: IFilterParams) => {
    const response = await request({
      url: 'v1/test_objectives',
      method: 'GET',
      params,
    });

    return response.data;
  },

  create: async (data: ITestObjectiveForm) => {
    try {
      const response = await request({
        url: 'v1/test_objectives',
        method: 'POST',
        data: {
          data: {
            test_objective: keysToSnakeCase(data),
          },
        },
      });

      return response;
    } catch (error: any) {
      return error?.response;
    }
  },

  update: async (id: number, data: ITestObjectiveEditForm) => {
    try {
      const response = await request({
        url: `v1/test_objectives/${id}`,
        method: 'PUT',
        data: {
          data: {
            test_objective: keysToSnakeCase(data),
          },
        },
      });

      return response;
    } catch (error: any) {
      return error?.response;
    }
  },

  search: async (productId: number, year: string) => {
    try {
      const response = await request({
        url: 'v1/test_objectives/search',
        method: 'GET',
        params: {
          product_id: productId,
          year,
        },
      });

      return response;
    } catch (error: any) {
      return error?.response;
    }
  },
};
